import axios from "axios";
import axiosApi from "./axios.js";
import Vue from "vue";
import {eventBus, vm} from "@/main";
import UserModel from "./UserModel";

axiosApi.interceptors.response.use(undefined, function (error) {
	if(error.response.status === 401) {
		UserModel.logout();
		eventBus.$emit('redirect_to_login_page',null);
		return Promise.reject(error);
	}else {
		return Promise.reject(error);
	}
});

export default class Api {


	static resize_image(path,width){
	var url=Vue.config.API_URL + 'v2/image/resize?width='+width+'&path='+path;
	return url;
	}
	static startParseText(text){
		var parsed_text=text.replace(/(https?:\/\/[^\s]+)/g, `<a class='mark' href="$1">$1</a>`);
		return text;
	}
	static findUrlInText(text){
		return text.match(/(https?:\/\/[^"\s>]+)/g);
	}
	static preventClick(e){
		e.preventDefault();

		return false;
	}
	static LoginCheckCode(code,type, success) {
		axiosApi.get(Vue.config.API_URL + `login_code/` + code+"/"+type)
			.then(response => {

				if (response.data.type == "success") {
					success(response.data);
				}
			})
			.catch(e => {

			})
	}

	static LoadFreelanceService(service_id,success){
		axiosApi.get(Vue.config.API_URL + 'freelance/get_service/'+service_id)
			.then(function (resp) {


				success(resp.data);




			})
			.catch(function () {

			});
	}
	static  loadLead(lead_id,success,error){
		// var api_token = localStorage.getItem('api_token');
		//
		//
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'lead/get/'+lead_id)
			.then(function (resp) {


				if(resp.data.type=="success"){
					success(resp.data);
				}else {
					error(resp.data.message);
				}





			})
			.catch(function () {

			});
	}
	static loadSaveProjectFields(params,success,projectid=null){
		params.is_need_update=true;
		var param_url=new URLSearchParams(params).toString();
		const searchParams = new URLSearchParams();

		Object.keys(params).forEach(key => searchParams.append(key, params[key]));
 		param_url=searchParams.toString();
 		if(projectid){
 			param_url=param_url+"&projectid="+projectid;
		}

		// var api_token = localStorage.getItem('api_token');
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;
		axiosApi.get(Vue.config.API_URL + 'projects/savefields?'+param_url)
			.then(function (resp) {


				success(resp.data);




			})
			.catch(function () {

			});
	}

	static loadLoginInfo(success){
		axiosApi.get(Vue.config.API_URL + 'login/info',)
		.then(function (resp) {


			success(resp.data);




		})
		.catch(function () {

		});
	}
	static loadScheduleByService(service_id,date,developer_id,success,error){
		//
		axiosApi.get(Vue.config.API_URL + 'freelance/get_schedule_by_service/'+service_id+"?date="+date+'&developer_id='+developer_id,)
		.then(function (resp) {

			if(resp.data.type=="success"){
				success(resp.data);
			}else {
				error(resp.data.message);
			}





		})
		.catch(function () {
			error('Произошла ошибка!');
		});
	}
	static loadAccount(success){
		axiosApi.get(Vue.config.API_URL + 'myaccount',)
			.then(function (resp) {


				success(resp.data);




			})
			.catch(function () {

			});
	}
	static changeManageSpectator(projectId,manage_spectator,success){

		var api_token = localStorage.getItem('api_token');

		//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

		axiosApi.get(Vue.config.API_URL + 'projects/setmanagespectator/'+projectId+"/"+manage_spectator,)
			.then(function (resp) {

				if(resp.data.type=="success" )	{
					success(resp.data.manage_spectator);
				}





			})
			.catch(function () {

			});
	}

	static addCommentReview(user_id,review_id,json,success,error){
		axiosApi.post(Vue.config.API_URL + 'v2/review/add_comment_review/'+user_id+"/"+review_id, json)
		.then(function (resp) {
			//alert('Успешно!');
			if (resp.data.type == "success") {

				success(resp.data);
			} else {

				error(resp.data.message);
			}

		})
		.catch(function (resp) {
			error("Произошла ошибка!");

		});

	}
	static addReview(user_id,new_review,success,error){
		axiosApi.post(Vue.config.API_URL + 'v2/review/add_review/'+user_id, new_review)
		.then(function (resp) {
			//alert('Успешно!');
			if (resp.data.type == "success") {

				success(resp.data);
			} else {

				error(resp.data.message);
			}

		})
		.catch(function (resp) {
			error("Произошла ошибка!");

		});
	}

	static updateProjectDateClient(last_id,json,success,error){

		var api_token = localStorage.getItem('api_token');


		axiosApi.post(Vue.config.API_URL + 'v2/projects/update_date_client/'+last_id,json)
		.then(function (resp) {


			if(resp.data.type=="success"){
				success(resp.data);
			}else {
				error(resp.data.message);
			}





		})
		.catch(function () {
			error("Произошла ошибка!");
		});
	}
	static loadProjectsCalendar(limit,offset,date,success){

		if(date.length==0){
			date="null";
		}
		var api_token = localStorage.getItem('api_token');


		axiosApi.get(Vue.config.API_URL + 'v2/projects/by_date_client/'+limit+"/"+offset+"/"+date)
		.then(function (resp) {


			success(resp.data);




		})
		.catch(function () {

		});
	}
	static loadProjectFields(params,success,projectId=null){
		var param_url=new URLSearchParams(params).toString();
		var api_token = localStorage.getItem('api_token');

		//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;
		if(projectId){
			param_url=param_url+"&projectid="+projectId;
		}
		axiosApi.get(Vue.config.API_URL + 'projects/fields?'+param_url,)
			.then(function (resp) {


				success(resp.data);




			})
			.catch(function () {

			});
	}

	static Pages_GetOnlyPage(alias,success,error){
		axiosApi.get(Vue.config.API_URL + 'pages/get_one_page/'+alias)
			.then(function (resp) {

				if(resp.data.type=="success"){
					success(resp.data);
				}else {
					error(resp.data);
				}





			})
			.catch(function () {

			})
	}
	static Pages_GetPage(alias,alias_page,success,error){

		axiosApi.get(Vue.config.API_URL + 'pages/get_page/'+alias+"/"+alias_page)
			.then(function (resp) {

				if(resp.data.type=="success"){
					success(resp.data);
				}else {
					error(resp.data);
				}





			})
			.catch(function () {

			})
	}
	static Pages_GetCategory(alias,success,error){

		axiosApi.get(Vue.config.API_URL + 'pages/get_category/'+alias)
			.then(function (resp) {

				if(resp.data.type=="success"){
					success(resp.data);
				}else {
					error(resp.data);
				}





			})
			.catch(function () {

			})
	}
	static loadCRMLeadField(success,error){

		var api_token = localStorage.getItem('api_token');


		//	axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'funnels/fields')
		.then(function (resp) {

			if(resp.data.type=="success"){
				success(resp.data);
			}else {
				error(resp.data.message);
			}





		})
		.catch(function () {

		});
	}
	static loadOnlyFunnel(funnel_id,success){

		var api_token = localStorage.getItem('api_token');


		//	axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'funnels/only_get/'+funnel_id)
			.then(function (resp) {

				if(resp.data.type=="success"){
					success(resp.data);
				}





			})
			.catch(function () {

			});
	}
	static loadFunnel(funnel_id,limit,offset,q_string,success,error){
		var api_token = localStorage.getItem('api_token');


		//	axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'funnels/get/'+funnel_id+"/"+limit+"/"+offset+"?q="+q_string)
			.then(function (resp) {


				if(resp.data.type=="success") {
					success(resp.data);
				}else {
					error(resp.data.message);
				}




			})
			.catch(function () {

			});
	}
	static loadShopFields(success){

		axiosApi.get(Vue.config.API_URL + 'shop/load_fields_order')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}
	static loadLeadFields(success){
		var api_token = localStorage.getItem('api_token');


		//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'lead/fields')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});

	}
	static confirmOrder(secretId,success){
		axiosApi.get(Vue.config.API_URL + 'lead/confirmorder/'+secretId)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}
	static acceptInviteLinkToProject(id,code,success){
		axiosApi.get(Vue.config.API_URL + 'invite/accept/'+id+'/'+code)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(id);
				}else {
					alert(resp.data.message);
				}


			})
			.catch(function () {

			});
	}
	static loadInviteToProject(id,code,success){
		axiosApi.get(Vue.config.API_URL + 'invite/load/'+id+'/'+code)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data.name);
				}


			})
			.catch(function () {

			});
	}
	static loadOrder(secretId,success){
		axiosApi.get(Vue.config.API_URL + 'lead/userorder/'+secretId)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}

	static download_pdf_offer(tag){
		window.open(Vue.config.API_URL+"download_portfolio/"+tag);
	}

	static wait(duration) {
		return new Promise((resolve) => setTimeout(resolve, duration));
	}

	static async  tryScrollToAnchor(hash, timeout = 1000, delay = 100) {
		while (timeout > 0) {
			const el = document.querySelector(hash);
			if (el) {
				el.scrollIntoView({ behavior: "smooth" });
				break;
			}
			await Api.wait(delay);
			timeout = timeout - delay;
		}
	}
	static startUserChangePassword(json,success,error){
		axiosApi.post(Vue.config.API_URL+'user/setting/change_password',json).then(function(resp){

			return success(resp.data);
		}).catch(function(err){
			return error(err);
		});
	}
	static startuserRegister(json,success,error){
		axiosApi.post(Vue.config.API_URL+'user/register',json).then(function(resp){

			return success(resp.data);
		}).catch(function(err){
			return error(err);
		});
	}

	static submitLoginandPass(json,success,error){
		axiosApi.post(Vue.config.API_URL+'login/check',json).then(function(resp){

			return success(resp.data);
		}).catch(function(err){
			return error(err);
		});
	}
	static checkVkIframeAuth(json,success){

		axiosApi.post(Vue.config.API_URL + 'vk_iframe/verify', json)
		.then(function (resp) {

			return success(resp.data);


		})
		.catch(function (err) {
			console.log('err',err);
			//error("Произошла ошибка!");
		});
	}

	static sendLog(log){
		var json={
			"log":log
		}
		axiosApi.post(Vue.config.API_URL + 'sendlog', json)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					//error(resp.data.message);
				}


			})
			.catch(function () {
				//error("Произошла ошибка!");
			});
	}
	static sendError(json){
		axiosApi.post(Vue.config.API_URL + 'errorlog/99J0jQST30IUZdczkTG492oXTsucEnorcxjUbqlzWpAzRCEVt4io', json)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					//error(resp.data.message);
				}


			})
			.catch(function () {
				//error("Произошла ошибка!");
			});
	}





	static loginByWidgetMatrix(userId,success){
		var data={};
		data.matrix_id=userId
		axiosApi.post(Vue.config.API_URL + 'login_matrix', data)
			.then(function (resp) {


				if (resp.data.type == "success") {

					return success(resp.data);
				} else {
					return error(resp.data.message);
				}


			})
			.catch(function () {
				return reject("Произошла ошибка!");
			});
	}
	static loginByMatrix(data,success,error){

		axiosApi.post(Vue.config.API_URL + 'login_matrix', data)
			.then(function (resp) {



				if (resp.data.type == "success") {

					return success(resp.data);
				} else {
					return error(resp.data.message);
				}


			})
			.catch(function () {
				return reject("Произошла ошибка!");
			});
	}
	static async loginByHash(json,success,error){


			axiosApi.post(Vue.config.API_URL + 'login_hash', json)
				.then(function (resp) {



					if (resp.data.type == "success") {

						success(resp.data);
					} else {
						error(resp.data.message);
					}


				})
				.catch(function (err) {
				  error(err.message);
				});







	}
	static  getParameterByName(name, url = window.location.href) {
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
	static saveMap(project_id,map,success,error){
		//var api_token = localStorage.getItem('api_token');


		//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		var params={};
		params['map']=map;


		axios.post(Vue.config.API_URL + 'projects/savemap/'+project_id, params)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					error(resp.data.message);
				}


			})
			.catch(function () {
				error("Произошла ошибка!");
			});

	}
	static getMap(project_id,success){
		var api_token = localStorage.getItem('api_token');


		//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'projects/getmap/'+project_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static searchTasks(project_id,q,success){
		var api_token = localStorage.getItem('api_token');


		//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'projects/searchtasks/'+project_id+'?q='+q)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static sendVoteAnswer(vote_id,json,success,error){
		axiosApi.post(Vue.config.API_URL +'editor/sendVoteResult/'+vote_id , json)
		.then(function (resp) {

			if (resp.data.type == "success") {

				success(resp.data);
			} else {
				error(resp.data.message);
			}


		})
		.catch(function () {
			error("Для того чтобы вам проголосовать, вам необходимо авторизоваться!");
		});
	}
	static FreelanceSetService(service_id,json,success,error){
		axiosApi.post(Vue.config.API_URL +'freelance/set_service/'+service_id , json)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					error(resp.data.message);
				}


			})
			.catch(function () {
				error("Произошла ошибка!");
			});
	}
	static ShopSettingSet(json,success,error){
		axiosApi.post(Vue.config.API_URL + 'shop/setting/set' , json)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					error(resp.data.message);
				}


			})
			.catch(function () {
				error("Произошла ошибка!");
			});
	}
	static blogBuyPost(post_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'blog/buy_post/'+post_id)
			.then(function (resp) {

				if(resp.data.type=="success"){
					success(resp.data);
				}else {
					error(resp.data.message);
				}




			})
			.catch(function () {

			});
	}
	static ShopSettingGet(success,error){

		axiosApi.get(Vue.config.API_URL + 'shop/setting/get')
			.then(function (resp) {

				if(resp.data.type=="success"){
					success(resp.data);
				}else {
					error(resp.data.message);
				}




			})
			.catch(function () {

			});
	}

	static getAllLeads(q,limit,offset,success,error){
		var api_token = localStorage.getItem('api_token');


		//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'lead/all/'+limit+'/'+offset+'?q='+q)
		.then(function (resp) {


			if(resp.data.type=="success"){
				success(resp.data);
			}else {
				error(resp.data.message);
			}



		})
		.catch(function () {

		});
	}
	static searchLead(q,success){
		var api_token = localStorage.getItem('api_token');


		//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'lead/search?q='+q)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}
	static loadFunnels(success){
		var api_token = localStorage.getItem('api_token');


			//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;


		axiosApi.get(Vue.config.API_URL + 'funnels/all')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});

	}
	static loadProjectArticlesList(id,search_string='',limit,offset,success){
		var api_token = localStorage.getItem('api_token');
		if (api_token) {

			//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

		}
		axiosApi.get(Vue.config.API_URL + 'projects/articles/list/'+id+'/' + limit + '/' + offset+'?q='+search_string)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}
	static loadCategoryPosts(alias,limit,offset,search_string='',success,error,orderby='last'){
		var api_token = localStorage.getItem('api_token');
		if (api_token) {

			//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

		}
		axiosApi.get(Vue.config.API_URL + 'blog/category/'+alias+'/' + limit + '/' + offset+'/'+orderby+"?q="+search_string)
			.then(function (resp) {

				if(resp.data.type=="success") {
					success(resp.data);
				}else {
					error(resp.data);
				}


			})
			.catch(function () {
				error();
			});
	}
	static loadPosts(limit, offset,search_string="", success,orderby='last') {
		var api_token = localStorage.getItem('api_token');
		if (api_token) {

			//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

		}
		axiosApi.get(Vue.config.API_URL + 'blog/all/' + limit + '/' + offset+'/'+orderby+"?q="+search_string)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static deleteCommentPost(comment_id, post_id, success) {
		axiosApi.get(Vue.config.API_URL + 'blog/delcomment/' + comment_id + '/' + post_id)
			.then(function (resp) {


				if (resp.data.type == "success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}

	static deleteSubCommentPost(subcomment_id, comment_id, post_id, success) {

		axiosApi.get(Vue.config.API_URL + 'blog/delsubcomment/' + subcomment_id + '/' + comment_id + '/' + post_id)
			.then(function (resp) {


				if (resp.data.type == "success") {
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}

	static loadArticleOne(id,post_id,search_string, success) {


		(async (id, success) => {

			var api_token = await localStorage.getItem('api_token');

			if (api_token) {

				//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

			}
			axiosApi.get(Vue.config.API_URL + 'projects/articles/get/' + id+'/'+post_id+'?q='+search_string)
				.then(function (resp) {

					if (resp.data.type && resp.data.type == "success") {
						success(resp.data);
					}


				})
				.catch(function () {

				});

		})(id, success);

	}
	static loadPost(id, success,error) {


		(async (id, success) => {

			var api_token = await localStorage.getItem('api_token');

			if (api_token) {

				//axios.defaults.headers.common['Authorization'] = `Bearer ` + api_token;

			}
			axiosApi.get(Vue.config.API_URL + 'blog/post/' + id)
				.then(function (resp) {

					if (resp.data.type && resp.data.type == "success") {
						success(resp.data.post);
					}else {
						error(resp.data);
					}


				})
				.catch(function () {

				});

		})(id, success);

	}

	static loadPage(id, success) {
		axiosApi.get(Vue.config.API_URL + 'page/' + id)
			.then(function (resp) {

				if (resp.data.type && resp.data.type == "success") {
					success(resp.data.page);
				}


			})
			.catch(function () {

			});
	}

	static loadPages(success) {

		axiosApi.get(Vue.config.API_URL + 'pages')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadVote(vote_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'editor/showVote/'+vote_id)
		.then(function (resp) {


			if(resp.data.type=="success"){
				success(resp.data);
			}else {
				error(resp.data);
			}



		})
		.catch(function (e) {

			//alert('errr');
		});

	}
	static loadAboutService(service_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'about/service/'+service_id)
			.then(function (resp) {


				if(resp.data.type=="success"){
					success(resp.data);
				}else {
					error();
				}



			})
			.catch(function (e) {

				//alert('errr');
			});
	}
	static loadAboutWorks_in_cat(category_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'about/works_in_cat/'+category_id)
			.then(function (resp) {


				if(resp.data.type=="success"){
					success(resp.data);
				}else {
					error();
				}



			})
			.catch(function (e) {

				//alert('errr');
			});
	}
	static getCart(){
		// try {
		//
		// }catch(err){
		// 	cart=[]
		// }
		var cart = undefined

		if (localStorage.getItem("cart") == null) {
			cart = [];
		} else {
			cart = JSON.parse(localStorage.getItem("cart"));
		}

		if (!Array.isArray(cart)) {
			cart = [];
		}
		return cart;

	}

	static addToCartFromItem(item,variant,success,error){


		var cart=Api.getCart();


		Api.CheckItemVariantIsAvalible(item.last_id,variant,function(){
			if(cart && cart[0] && cart[0].user_id!=item.user_id){
				return error("У вас <a href='/cart'>в корзине</a> есть товары другого <a href='/id"+cart[0].user_id+"/catalog'>продавца</a>! Удалите их!");
			}
			if(cart && cart[0] && cart[0].currency!=item.currency){
				return error("У вас <a href='/cart'>в корзине</a> есть товары другого <a href='/id"+cart[0].user_id+"/catalog'>продавца</a>! Удалите их!");
			}
			cart.push(item);

			Api.setCart(cart);
			success();
		},function(err){
			error(err)
		})





	}


	static addToCart(item,success,error){


		var cart=Api.getCart();


		Api.CheckItemIsAvalible(item.last_id,function(){
			if(cart && cart[0] && cart[0].user_id!=item.user_id){
			return error("У вас <a href='/cart'>в корзине</a> есть товары другого <a href='/id"+cart[0].user_id+"/catalog'>продавца</a>! Удалите их!");
			}
			if(cart && cart[0] && cart[0].currency!=item.currency){
			 return error("У вас <a href='/cart'>в корзине</a> есть товары другого <a href='/id"+cart[0].user_id+"/catalog'>продавца</a>! Удалите их!");
			}
			cart.push(item);

			Api.setCart(cart);
			success();
		},function(err){
			error(err)
		})





	}
	static deleteInvoice(invoce_id,success,error){
		axiosApi.get(Vue.config.API_URL+'invoices/delete/'+invoce_id).then(function(resp){
			if (resp.data.type == "success") {

				success(resp.data);
			} else {
				error(resp.data.message);
			}
		}).catch(function () {
			error("Произошла ошибка!");
		});
	}
	static loadCurrencys(success,error){
		axiosApi.get(Vue.config.API_URL + 'about/load_currencys' )
		.then(function (resp) {

			if (resp.data.type == "success") {

				success(resp.data);
			} else {
				error(resp.data.message);
			}


		})
		.catch(function () {
			error("Произошла ошибка!");
		});

	}
	static CheckItemVariantIsAvalible(item_last_id,variant,success,error ){
		axiosApi.get(Vue.config.API_URL + 'shop/check_item/'+item_last_id+"?variant="+variant )
		.then(function (resp) {

			if (resp.data.type == "success") {

				success(resp.data);
			} else {
				error(resp.data.message);
			}


		})
		.catch(function () {
			error("Произошла ошибка!");
		});
	}
	static checkPromoCode(json,success,error){
		axiosApi.post(Vue.config.API_URL + 'shop/check_promocode',json )
		.then(function (resp) {

			if (resp.data.type == "success") {

				success(resp.data);
			} else {
				error(resp.data.message);
			}


		})
		.catch(function () {
			error("Произошла ошибка!");
		});
	}
	static CheckItemIsAvalible(item_last_id,success,error ){
		axiosApi.get(Vue.config.API_URL + 'shop/check_item/'+item_last_id )
		.then(function (resp) {

			if (resp.data.type == "success") {

				success(resp.data);
			} else {
				error(resp.data.message);
			}


		})
		.catch(function () {
			error("Произошла ошибка!");
		});
	}
	static setCart(cart){
		localStorage.setItem("cart",JSON.stringify(cart));
		Api.syncCart();
	}

	static getOnlyDeliveryPrice(currencys,delivery){
		var cart=Api.getCart();
		var i=0;
		var type_currencys=currencys;
		var currencys={};
		var currencys_delivery={};
		var i=0;
		while(type_currencys[i]){
			var cur_currency=type_currencys[i];
			currencys[cur_currency]=0;
			i++;
		}

		i=0;



		if(cart.length>0){
			while(cart[i]){
				var row=cart[i];
				var start_price=parseFloat(row.price);
				var option_i=0;
				if(row.options.length>0){
					while(row.options[option_i]){
						var option=row.options[option_i];
						if(row.custom_options[option_i] && row.custom_options[option_i]==true){
							start_price+=parseFloat(option.price);
						}
						option_i+=1;
					}
				}
				start_price=start_price*row.count;

				currencys[row.currency]=currencys[row.currency]+start_price;
				i++;
			}
		}


		var i=0;

		while(type_currencys[i]){
			var cur_currency=type_currencys[i];
			var current=currencys[cur_currency];
			if(!(current>=delivery.free_from) && delivery.price>0){
				currencys_delivery[cur_currency]=parseInt(delivery.price);
			}else {
				currencys_delivery[cur_currency]=0;
			}

			i++;
		}

		return currencys_delivery;
	}
	static getTotalPriceWithDelivery(currencys,delivery){

		var cart=Api.getCart();
		var i=0;
		var type_currencys=currencys;
		var currencys={};
		var i=0;
		while(type_currencys[i]){
			var cur_currency=type_currencys[i];
			currencys[cur_currency]=0;
			i++;
		}

		i=0;



		if(cart.length>0){
			while(cart[i]){
				var row=cart[i];
				var start_price=parseFloat(row.price);
				var option_i=0;
				if(row.options.length>0){
					while(row.options[option_i]){
						var option=row.options[option_i];
						if(row.custom_options[option_i] && row.custom_options[option_i]==true){
							start_price+=parseFloat(option.price);
						}
						option_i+=1;
					}
				}
				start_price=start_price*row.count;

				currencys[row.currency]=currencys[row.currency]+start_price;
				i++;
			}
		}


		var i=0;
		while(type_currencys[i]){
			var cur_currency=type_currencys[i];
			var current=currencys[cur_currency];
			if(!(current>=delivery.free_from) && delivery.price>0){
			 currencys[cur_currency]=current+parseInt(delivery.price);
			}

			i++;
		}

		return currencys;
	}
	static getTotalPrice(currencys){
		var cart=Api.getCart();
		var i=0;
		var type_currencys=currencys;
		var currencys={};
		var i=0;
		while(type_currencys[i]){
			var cur_currency=type_currencys[i];
			currencys[cur_currency]=0;
			i++;
		}

		i=0;



		if(cart.length>0){
			while(cart[i]){
				var row=cart[i];
				var start_price=parseFloat(row.price);
				var option_i=0;
				if(row.options.length>0){
					while(row.options[option_i]){
						var option=row.options[option_i];
						if(row.custom_options[option_i] && row.custom_options[option_i]==true){
							start_price+=parseFloat(option.price);
						}
						option_i+=1;
					}
				}
				start_price=start_price*row.count;

				currencys[row.currency]=currencys[row.currency]+start_price;
				i++;
			}
		}

		return currencys;
	}
	static syncCart(){
		var total_price=0;


		var cart=Api.getCart();


		eventBus.$emit('sync_cart', cart);


	}
	static loadItem_by_last_id(last_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'shop/item/'+last_id)
			.then(function (resp) {

				if(resp.data.type && resp.data.type=="success"){
					success(resp.data);
				}else {
					error();
				}



			})
			.catch(function (e) {

				//alert('errr');
			});
	}
	static loadAllItems(limit,offset,category_id,q_search,success){
		axiosApi.get(Vue.config.API_URL + 'shop/get_all_items/'+limit+'/'+offset+'?category_id='+category_id+"&q="+q_search)
			.then(function (resp) {

				if(resp.data.type && resp.data.type=="success"){
					success(resp.data);
				}



			})
			.catch(function (e) {

				//alert('errr');
			});
	}
	static loadItemsCategory(category_id,success){
		axiosApi.get(Vue.config.API_URL + 'shop/category/'+category_id)
			.then(function (resp) {

				if(resp.data.type && resp.data.type=="success"){
					success(resp.data);
				}



			})
			.catch(function (e) {

				//alert('errr');
			});
	}
	static loadAboutcategorys_portfolio(success){
		axiosApi.get(Vue.config.API_URL + 'about/categorys_portfolio')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function (e) {

				//alert('errr');
			});
	}
	static loadAboutGetConfWithUrl(url,success) {
		// if(localStorage.hasOwnProperty("get_conf_"+url)){
		// 	var json=localStorage.getItem("get_conf_"+url);
		//
		// 	json=JSON.parse(json);
		// 	success(json);
		// 	return;
		// }

		axiosApi.get(Vue.config.API_URL + 'about/get_conf?current_url='+url)
			.then(function (resp) {

				localStorage.setItem("get_conf_"+url,JSON.stringify(resp.data));
				success(resp.data);


			})
			.catch(function () {

			});
	}
	static loadAboutGetConf(success) {

		axiosApi.get(Vue.config.API_URL + 'about/get_conf')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}
	static loadServicesList(limit,offset,success) {

		axiosApi.get(Vue.config.API_URL + 'services/list/'+limit+"/"+offset)
		.then(function (resp) {


			success(resp.data);


		})
		.catch(function () {

		});
	}
	static loadAbout(success) {

		axiosApi.get(Vue.config.API_URL + 'about')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadStatsInvoices(success) {
		//axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// if(localStorage.getItem('user')){
		// 	var user_login=localStorage.getItem('user');
		// 	if (user_login.api_token) {
		// 		axios.defaults.headers.common['Authorization'] = `Bearer ` + user_login.api_token;
		// 	}
		// }
		axiosApi.get(Vue.config.API_URL + 'invoices/stats')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadStats(success) {

		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }

		axiosApi.get(Vue.config.API_URL + 'projects/stats')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static setReadAllNotify(success) {
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.get(Vue.config.API_URL + 'notify/readall')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static setRemoveNotify(notify_id, success) {
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.get(Vue.config.API_URL + 'notify/remove/' + notify_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static setReadNotify(notify_id, success) {
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.get(Vue.config.API_URL + 'notify/setread/' + notify_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadNotifyCount(success) {
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.get(Vue.config.API_URL + 'notify/count')
			.then(function (resp) {


				success(resp.data);


			});
	}

	static createShopOrder(params,success,error){
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.post(Vue.config.API_URL + 'shop/create_order' , params)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					error(resp.data.message);
				}


			})
			.catch(function () {
				error("Произошла ошибка!");
			});
	}
	static sendReview(params, id, success) {
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.post(Vue.config.API_URL + 'invoices/sendreview/' + id, params)
			.then(function (resp) {

				if (resp.data.type == "success") {

					success(resp.data);
				} else {
					error(resp.data.message);
				}


			})
			.catch(function () {
				error("Произошла ошибка!");
			});
	}

	static loadNotify(params, success) {
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.post(Vue.config.API_URL + 'notify/all/'+params.limit+"/"+params.offset, params)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadUserPortfolio() {

		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.get(Vue.config.API_URL + 'portfolio/all')
			.then(function (resp) {


				eventBus.$emit('load_portfolio_user', resp.data);


			})
			.catch(function () {

			});
	}


	static async loadUserByOneCode(onecode){

		return	new Promise((resolve, reject) => {

			axios.get(Vue.config.API_URL + 'oauth/check/'+onecode)
				.then(function (resp) {

					UserModel.set(resp.data);
					return resolve(resp.data);



				})
				.catch(function (e) {
					//eventBus.$emit('user_is_login', null);

					return reject(e);
					// if(localStorage.getItem('user')){
					// 	localStorage.removeItem('user');
					// }
				});
		});






	}
	static async loadUserByToken2(token,success,error){

		axios.defaults.headers.common['Authorization'] = `Bearer ` + token;
		axios.get(Vue.config.API_URL + 'user')
		.then(function (resp) {

			UserModel.set(resp.data);
			return success(resp.data);



		})
		.catch(function (e) {
			//eventBus.$emit('user_is_login', null);

			return error(e);
			// if(localStorage.getItem('user')){
			// 	localStorage.removeItem('user');
			// }
		});






	}
	static async loadUserByToken(token){

		return	new Promise((resolve, reject) => {
			axios.defaults.headers.common['Authorization'] = `Bearer ` + token;
			axios.get(Vue.config.API_URL + 'user')
				.then(function (resp) {

					UserModel.set(resp.data);
					return resolve(resp.data);



				})
				.catch(function (e) {
					//eventBus.$emit('user_is_login', null);
					UserModel.logout();
					eventBus.$emit('redirect_to_login_page',null);


					return reject(e);
					// if(localStorage.getItem('user')){
					// 	localStorage.removeItem('user');
					// }
				});
		});






	}

	static loadUserInfo(token) {


		axios.defaults.headers.common['Authorization'] = `Bearer ` + token;
		axios.get(Vue.config.API_URL + 'user')
			.then(function (resp) {

				UserModel.set(resp.data);

				var url_after_redirect = localStorage.getItem('url_after_login');
				if (url_after_redirect) {
					url_after_redirect = JSON.parse(url_after_redirect);
					localStorage.removeItem('url_after_login');

					vm.$router.push(url_after_redirect);
				}


			})
			.catch(function () {
				//eventBus.$emit('user_is_login', null);
				if(localStorage.getItem('user')){
					localStorage.removeItem('user');
				}
			});
	}

	static load_get_blog_category_by_id(category_id,callback){
		axiosApi.get(Vue.config.API_URL + 'blog/get_blog_category_by_id/'+category_id)
			.then(function (resp) {


				if(resp.data.type=="success"){
					callback(resp.data);
				}



			})
			.catch(function () {

			});
	}
	static loadBlogFormCategorysWithId(category_id,callback,token=undefined){
		// var use_token;
		// if(token!=undefined){
		// 	use_token=token;
		// }else {
		// 	use_token=vm.$store.getters.TOKEN;
		// }
		//
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		// if(localStorage.getItem('user')){
		// 	var user_login=localStorage.getItem('user');
		// 	if (user_login.api_token) {
		// 		axios.defaults.headers.common['Authorization'] = `Bearer ` + user_login.api_token;
		// 	}
		// }
		axiosApi.get(Vue.config.API_URL + 'blog/form_categorys?last_id='+category_id)
			.then(function (resp) {


				callback(resp.data);


			})
			.catch(function () {

			});
	}
	static loadBlogFormCategorys(callback,token=undefined){
		// var use_token;
		// if(token!=undefined){
		// 	use_token=token;
		// }else {
		// 	use_token=vm.$store.getters.TOKEN;
		// }
		//
		// axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		// if(localStorage.getItem('user')){
		// 	var user_login=localStorage.getItem('user');
		// 	if (user_login.api_token) {
		// 		axios.defaults.headers.common['Authorization'] = `Bearer ` + user_login.api_token;
		// 	}
		// }
		axiosApi.get(Vue.config.API_URL + 'blog/form_categorys')
			.then(function (resp) {


				callback(resp.data);


			})
			.catch(function () {

			});
	}
	static loadBlogCategorys(callback,token=undefined) {
		// var use_token;
		// if(token!=undefined){
		// 	use_token=token;
		// }else {
		// 	use_token=vm.$store.getters.TOKEN;
		// }

		//axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		// if(localStorage.getItem('user')){
		// 	var user_login=localStorage.getItem('user');
		// 	if (user_login.api_token) {
		// 		axios.defaults.headers.common['Authorization'] = `Bearer ` + user_login.api_token;
		// 	}
		// }
		axiosApi.get(Vue.config.API_URL + 'blog/categorys')
			.then(function (resp) {


				callback(resp.data);


			})
			.catch(function () {

			});
	}
	static loadCoordinatesByAddr(addr,callback){
		var url_upload=Vue.config.API_URL + 'editor/search_one_adress';
		var data={"addr":addr}
		axiosApi.post(url_upload, data, {

		}).then(function (resp) {


			if(resp.data.addr){

				callback(resp.data);
			}



		}).catch((error) => {


		});
	}
	static loadFile(data,callback){
		//var use_token=vm.$store.getters.TOKEN;
		var url_upload=Vue.config.API_URL + 'editor/uploadFile';

		///	axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		var tmpUser=UserModel.get();
		if(tmpUser && tmpUser.api_token){
			///axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		}

		axiosApi.post(url_upload, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		}).then(function (resp) {

			if(resp.data.success==1){
				callback(resp.data);
			}



		}).catch((error) => {

		});



	}
	static loadImage(data,callback){
		//var use_token=vm.$store.getters.TOKEN;
		var url_upload=Vue.config.API_URL + 'editor/uploadImage';

	///	axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		var tmpUser=UserModel.get();
		if(tmpUser && tmpUser.api_token){
			///axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		}

		axiosApi.post(url_upload, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		}).then(function (resp) {

			if(resp.data.success==1){
				callback(resp.data);
			}



		}).catch((error) => {

		});



	}
	static loadShopMyItem(id,callback){
		//var use_token=vm.$store.getters.TOKEN;


		// axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }

		axiosApi.get(Vue.config.API_URL + 'shop/my/item/'+id)
			.then(function (resp) {

				if(resp.data.type=="success"){

					callback(resp.data);
				}





			})
			.catch(function () {

			});
	}
	static loadShopItems(limit,offset,callback){
		var use_token=vm.$store.getters.TOKEN;


		// axios.defaults.headers.common['Authorization'] = `Bearer ` + use_token;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }

		axiosApi.get(Vue.config.API_URL + 'shop/my/all_items/'+limit+"/"+offset)
			.then(function (resp) {

			       callback(resp.data);





			})
			.catch(function () {

			});
	}
	static loadCategorys(callback) {


		axiosApi.get(Vue.config.API_URL + 'categorys/all')
			.then(function (resp) {


				callback(resp.data);


			})
			.catch(function () {

			});
	}

	static loadShopCategorys(success){

		axiosApi.get(Vue.config.API_URL + 'shop/categorys/all')
			.then(function (resp) {


				if(resp.data && resp.data.type && resp.data.type=="success"){
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}

	static loadUserPortfolioCategorys(success){
		axiosApi.get(Vue.config.API_URL + 'portfolio/categorys')
			.then(function (resp) {

				success(resp.data);


			})
			.catch(function () {

			});
	}
	static loadUserPortfolioWork(id,success){
		axiosApi.get(Vue.config.API_URL + 'portfolio/get_work/'+id)
			.then(function (resp) {


				if(resp.data && resp.data.type && resp.data.type=="success"){
					success(resp.data);
				}


			})
			.catch(function () {

			});
	}

	static loadPortfolioCategorys() {

		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.get(Vue.config.API_URL + 'portfolio/categorys')
			.then(function (resp) {


				eventBus.$emit('load_portfolio_categorys', resp.data);


			})
			.catch(function () {

			});
	}

	static loadPortfolioCategorysModal(success) {

		// axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		// var tmpUser=UserModel.get();
		// if(tmpUser && tmpUser.api_token){
		// 	axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		// }
		axiosApi.get(Vue.config.API_URL + 'portfolio/categorys')
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadInvoice(id,success) {



		axiosApi.get(Vue.config.API_URL + 'invoices/get/' + id)
			.then(function (resp) {


				if (resp.data.type == "success") {
					success(resp.data)
				}


			})
			.catch(function () {

			});
	}

	static loadArticleOptions(id,success){
		axiosApi.get(Vue.config.API_URL + 'projects/articles/options/' + id)
			.then(function (resp) {


				if (resp.data.type == "success") {

					success(resp.data)
				}


			})
			.catch(function () {

			});
	}
	static loadProjectv2(id,success){
		axiosApi.get(Vue.config.API_URL + 'projects/get2/' + id)
			.then(function (resp) {


				if (resp.data.type == "success") {

					success(resp.data)
				}


			})
			.catch(function () {

			});
	}
	static loadProjectNew(id,success,error) {


		axiosApi.get(Vue.config.API_URL + 'projects/get/' + id)
		.then(function (resp) {


			if (resp.data.type == "success") {

				resp.data.project.json = JSON.parse(resp.data.project.json);
				success(resp.data);
			}else {
				error();
			}


		})
		.catch(function () {

		});
	}
	static loadProject(id) {


		axiosApi.get(Vue.config.API_URL + 'projects/get/' + id)
			.then(function (resp) {


				if (resp.data.type == "success") {

					resp.data.project.json = JSON.parse(resp.data.project.json);
					eventBus.$emit('is_load_project', resp.data);
				}


			})
			.catch(function () {

			});
	}

	static loadInvoices(limit,offset,filter={},success) {



		axiosApi.post(Vue.config.API_URL + 'invoices/all/'+limit+"/"+offset,{filter:filter})
			.then(function (resp) {



				success(resp.data);


			})
			.catch(function () {

			});
	}

	static createWithdrawalRequest(post_data,success,error){

		axiosApi.post(Vue.config.API_URL + 'v2/withdrawall/create',post_data)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}

	static loadUserPageOnePortfolio(id,work_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_one_work/'+id+"/"+work_id,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUserPagePortfolio(id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_all_portfolio/'+id,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadReward(id,success){
		axiosApi.get(Vue.config.API_URL + 'v2/rewards/one/'+id,)
		.then(function (resp) {

			if(resp.data.type=="success"){
				return success(resp.data);
			}



		})
		.catch(function (e) {

		});
	}
	static rewardsChangePrivacy(status,success){
		axiosApi.get(Vue.config.API_URL + 'v2/rewards/change_privacy/'+status,)
		.then(function (resp) {

			if(resp.data.type=="success"){
				return success(resp.data);
			}



		})
		.catch(function (e) {

		});
	}
	static loadRewards(limit,offset,success){
		axiosApi.get(Vue.config.API_URL + 'v2/rewards/list/'+limit+"/"+offset,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

		});
	}
	static loadUserPageRewards(id,limit,offset,success){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_rewards/'+id+"/"+limit+"/"+offset)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUserPageItems(limit,offset,id,category=0,q_search,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_all_items/'+id+"/"+limit+"/"+offset+"/"+category+"?q="+q_search,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUserPageAddReview(id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_invoices/'+id,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUserPageOneReview(user_id,review_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_review/'+user_id+"/"+review_id,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUserPageReviews(id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_reviews/'+id,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}

	static sendVerificationForm(id,data,success,error){

		axiosApi.post(Vue.config.API_URL + 'v2/verifications/send/'+id,data)
		.then(function (resp) {
			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadVerificationForm(id,success,error){

		axiosApi.get(Vue.config.API_URL + 'v2/verifications/get/'+id,)
		.then(function (resp) {
			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUsersList(limit,offset,service_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_all_developers/'+limit+"/"+offset+"?service_id="+service_id,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUserPageServices(limit,offset,id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_services/'+id+"/"+limit+"/"+offset,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUserPageService(id,service_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_service/'+id+"/"+service_id,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadUserPageMain(id,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/users/get_main/'+id,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}

	static loadWithdrawalStatus(success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/withdrawall/status',)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadWithdrawal(limit,offset,success,error){
		axiosApi.get(Vue.config.API_URL + 'v2/withdrawall/all/'+limit+"/"+offset,)
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function (e) {

			return error(e);
		});
	}
	static loadTasksWithFilterApiv2(filter,project_id,offset,limit,success){


		axiosApi.post(Vue.config.API_URL + 'v2/tasks/all/'+project_id+'/'+limit+'/'+offset,{"filter":filter})
		.then(function (resp) {


			return success(resp.data);


		})
		.catch(function () {

		});
	}
	static loadTasksWithFilter(filter,project_id,success){


		axiosApi.post(Vue.config.API_URL + 'projects/tasks/'+project_id,{"filter":filter})
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadProjectsWithFilter(filter,success){


		axiosApi.post(Vue.config.API_URL + 'projects/all',{"filter":filter})
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadLeadsTasks(limit,offset,success,error){


		axiosApi.get(Vue.config.API_URL + 'lead/tasksall/'+limit+"/"+offset)
			.then(function (resp) {


				if(resp.data.type && resp.data.type=="success"){
					return success(resp.data);
				}else {
					return error(resp.data.message);
				}



			})
			.catch(function () {

			});
	}

	static loadFreelanceWithFilterv2(limit,offset,filter,success){


		axiosApi.post(Vue.config.API_URL + 'v2/freelance/all/'+limit+"/"+offset,{"filter":filter})
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadProjectsWithFilterv2(limit,offset,filter,success){


		axiosApi.post(Vue.config.API_URL + 'v2/projects/all/'+limit+"/"+offset,{"filter":filter})
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}

	static loadProjectsv2(limit,offset,success){
		axiosApi.get(Vue.config.API_URL + 'v2/projects/all/'+limit+"/"+offset)
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}
	static loadProjects(success) {



		axiosApi.get(Vue.config.API_URL + 'projects/all')
			.then(function (resp) {


				return success(resp.data);


			})
			.catch(function () {

			});
	}

	static deleteUserPortfolio(id) {


		axiosApi.get(Vue.config.API_URL + 'portfolio/delete/' + id)
			.then(function (resp) {


			})
			.catch(function () {

			});
	}
	static makeInvoice(id, project_id, success) {

		axiosApi.get(Vue.config.API_URL + 'projects/makeinvoice/' + id + "/" + project_id)
		.then(function (resp) {
			success(resp.data);


		})
		.catch(function () {

		});
	}
	static cancelInvoice(id, project_id, success) {

		axiosApi.get(Vue.config.API_URL + 'projects/cancelinvoice/' + id + "/" + project_id)
		.then(function (resp) {
			success(resp.data);


		})
		.catch(function () {

		});
	}
	static removeInvoice(id, project_id, success) {

		axiosApi.get(Vue.config.API_URL + 'projects/removeinvoice/' + id + "/" + project_id)
			.then(function (resp) {
				success(resp.data);


			})
			.catch(function () {

			});
	}
	static getProjectInvoices(id,limit,offset,success,err){

		axiosApi.get(Vue.config.API_URL + 'projects/invoices/'+id+'/'+limit+'/'+offset)
		.then(function (resp) {


			if(resp.data.type=="success"){
				success(resp.data);
			}else {
				error(resp.data.message);
			}



		})
		.catch(function () {

		});
	}
	static removeTaskLink(project_id,relation_id, success) {

		axiosApi.get(Vue.config.API_URL + 'projects/removelink/' + project_id + "/" + relation_id)
		.then(function (resp) {
			if(resp.data.type=="success"){
				success(resp.data);
			}



		})
		.catch(function () {

		});
	}
	static addTaskLink(task_id, newLink, success, error) {

		axiosApi.post(Vue.config.API_URL + 'projects/addlink/' + task_id, newLink)
		.then(function (resp) {
			//alert('Успешно!');
			if (resp.data.type == "success") {
				success(resp.data);
			} else {
				error(resp.data.message);
			}

		})
		.catch(function (resp) {
			error("Произошла ошибка!");

		});
	}
	static addProjectInvoice(project_id, newInvoice, success, error) {

		axiosApi.post(Vue.config.API_URL + 'projects/addinvoice/' + project_id, newInvoice)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data);
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!");

			});
	}

	static chooseOfferProject(project_id, offer_id, success) {

		axiosApi.get(Vue.config.API_URL + 'freelance/choose/' + project_id + "/" + offer_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.project)
				}

			})
			.catch(function (resp) {

			});
	}

	static sendPostSubComment(post_id, comment_id, comment, success) {

		axiosApi.post(Vue.config.API_URL + 'blog/comments/sendsub/' + post_id + "/" + comment_id, {"comment": comment})
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comments)
				}

			})
			.catch(function (resp) {

			});
	}

	static sendSubComment(project_id, comment_id, comment, success) {

		axiosApi.post(Vue.config.API_URL + 'comments/sendsub/' + project_id + "/" + comment_id, {"comment": comment})
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comments)
				}

			})
			.catch(function (resp) {

			});
	}

	static sendOfferComment(project_id, offer_id, comment, success) {

		axiosApi.post(Vue.config.API_URL + 'freelance/sendcomment/' + project_id + "/" + offer_id, {"comment": comment})
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comments)
				}

			})
			.catch(function (resp) {

			});
	}

	static updateLead(lead,lead_id,success,error){

		axiosApi.post(Vue.config.API_URL + 'lead/edit/'+lead_id , lead)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data);
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static  addLead(new_lead,success,error){


		axiosApi.post(Vue.config.API_URL + 'lead/add' , new_lead)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data);
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static sendOffer(newOffer, success, error) {

		axiosApi.post(Vue.config.API_URL + 'freelance/send/' + newOffer.project_id, newOffer)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.offer)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static setFinishTask(task_data,lead_id,success,error){

		axiosApi.post(Vue.config.API_URL + 'lead/setfinishtask/' + lead_id, task_data)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static sendLinkToClient(lead_id,success,error){
		axiosApi.get(Vue.config.API_URL + 'lead/sendlink/'+lead_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
    static deleteLeadTask(task_id,lead_id,success,error){

		axiosApi.get(Vue.config.API_URL + 'lead/deletetask/' + lead_id+"/"+task_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static sendEmailLead(newEmail,lead_id,success,error){
		axiosApi.post(Vue.config.API_URL + 'lead/sendemail/' + lead_id, newEmail)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static addLeadTask(newTask,lead_id,success,error){

		axiosApi.post(Vue.config.API_URL + 'lead/addtask/' + lead_id, newTask)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static addLeadComment(newComment, lead_id, success, error) {

		axiosApi.post(Vue.config.API_URL + 'lead/addcomment/' + lead_id, newComment)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.all_objects)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static addPostComment(newComment, post_id, success, error) {

		axiosApi.post(Vue.config.API_URL + 'blog/commentadd/' + post_id, newComment)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comment)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static addShopOrderComment(newComment,invoice_id,order_id,success,error){
		axiosApi.post(Vue.config.API_URL + 'invoices/addcomment/' + invoice_id+"/"+order_id, newComment)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comment)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}
	static addComment(newComment, project_id, success, error) {

		axiosApi.post(Vue.config.API_URL + 'comments/add/' + project_id, newComment)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.comment)
				} else {
					error(resp.data.message);
				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static deleteSpectator(project_id, user_id, success) {

		axiosApi.get(Vue.config.API_URL + 'users/delete/' + project_id + "/" + user_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.users);


				} else {

					//   error(resp.data.message)
				}

			})
			.catch(function (resp) {
				// error("Произошла ошибка!")

			});
	}
	static deleteInviteLink(project_id,invite_id,success,error){

		axiosApi.get(Vue.config.API_URL + 'users/deleteinvite/' + project_id+"/"+invite_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.invites);


				} else {

					error(resp.data.message)
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!")

			});
	}
	static createInviteLinkforProject(project_id,count_invites,success,error){

		axiosApi.get(Vue.config.API_URL + 'users/createinvite/' + project_id+"/"+count_invites)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.invites);


				} else {

					error(resp.data.message)
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!")

			});
	}

	static addUser(project_id, username, success, error) {

		axiosApi.post(Vue.config.API_URL + 'users/add/' + project_id, {"username": username})
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success(resp.data.users);


				} else {

					error(resp.data.message)
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!")

			});
	}
	static setAccountWalletTon(formdata, success, error) {
		axiosApi.post(Vue.config.API_URL + 'setaccount/wallet_ton', formdata)
		.then(function (resp) {
			//alert('Успешно!');
			if (resp.data.type == "success") {
				success();


			} else {

				error(resp.data.message)
			}

		})
		.catch(function (resp) {
			error("Произошла ошибка!")

		});
	}
	static setAccount(formdata, success, error) {
		axiosApi.post(Vue.config.API_URL + 'setaccount', formdata)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success();


				} else {

					error(resp.data.message)
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка!")

			});
	}
	static setShopNewStatus(status_id,invoice_id,order_id,success){
		axiosApi.get(Vue.config.API_URL + 'invoices/setstatus/' + invoice_id + "/"+order_id+"/" + status_id)
			.then(function (resp) {

				if(resp.data.type=="success"){
					success(resp.data);
				}



			})
			.catch(function () {

			});
	}

	static setNewStatus(status_id, project_id, success) {

		axiosApi.get(Vue.config.API_URL + 'projects/newstatus/' + project_id + "/" + status_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static approveInvoice(id, project_id, success) {

		axiosApi.get(Vue.config.API_URL + 'projects/approveinvoice/' + id + "/" + project_id)
			.then(function (resp) {


				success(resp.data);


			})
			.catch(function () {

			});
	}

	static completeInvoice(id, project_id, success) {

		axiosApi.get(Vue.config.API_URL + 'projects/completeinvoice/' + id + "/" + project_id)
			.then(function (resp) {

				success(resp.data);


			})
			.catch(function () {

			});
	}

	static login_by_token(token,success){




		axiosApi.get(Vue.config.API_URL + 'user')
			.then(function (resp) {

				success(resp.data);

			})
			.catch(function () {






				// this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
				// vm.$forceUpdate();
				// window.location.href = "/";
			});
	}
	static login(to, next) {







		axiosApi.get(Vue.config.API_URL + 'user')
			.then(function (resp) {

				next();

			})
			.catch(function () {


				localStorage.setItem('url_after_login', to.fullPath);
				vm.$router.push({"name": "landing"});



				// this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
				// vm.$forceUpdate();
				// window.location.href = "/";
			});
	}

	static addItem(newItem,success,error){
		//axios.defaults.headers.common['Authorization'] = `Bearer ` + vm.$store.getters.TOKEN;
		var tmpUser=UserModel.get();
		if(tmpUser && tmpUser.api_token){
			//axios.defaults.headers.common['Authorization'] = `Bearer ` + tmpUser.api_token;
		}
		axiosApi.post(Vue.config.API_URL + 'shop/my/add', newItem)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success();

				} else {
					error(resp.data.message);

				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static addWork(newWork, success, error) {

		axiosApi.post(Vue.config.API_URL + 'portfolio/add', newWork)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {
					success();

				} else {
					error(resp.data.message);

				}

			})
			.catch(function (resp) {

				error("Произошла ошибка!");
			});
	}

	static invoiceSetPay(id, callback) {

		axiosApi.get(Vue.config.API_URL + 'invoices/setpay/' + id)
			.then(function (resp) {

				if (resp.data.type == "success") {
					callback();
				}


			})
			.catch(function () {

			});
	}

	static invoiceUnFreeze(id,callback){
		axiosApi.get(Vue.config.API_URL + 'invoices/unfreeze_invoice/' + id)
		.then(function (resp) {

			if (resp.data.type == "success") {
				callback()
			}


		})
		.catch(function () {

		});
	}
	static invoiceFinishPay(id, callback) {

		axiosApi.get(Vue.config.API_URL + 'invoices/finishpay/' + id)
			.then(function (resp) {

				if (resp.data.type == "success") {
					callback()
				}


			})
			.catch(function () {

			});
	}

	static addTask(editProject, success, error) {

		axiosApi.post(Vue.config.API_URL + 'projects/addtask/' + editProject.last_id, editProject)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					success(resp.data.tasks);
				} else {

					error(resp.data.message);
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка");

			});
	}

	static editProject(editProject, success, error) {

		axiosApi.post(Vue.config.API_URL + 'projects/edit_project/' + editProject.last_id, editProject)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					success({iserror: false});
				} else {

					error(resp.data.message);
				}

			})
			.catch(function (resp) {
				error("Произошла ошибка");

			});
	}

	static deleteArticleinProject(project_id,post_id,success){
		axiosApi.get(Vue.config.API_URL + 'projects/articles/delete/' + project_id+"/"+post_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					success(resp.data.post);
				}

			})
			.catch(function (resp) {


			});
	}
	static changeEnablePost(post_id, success) {

		axiosApi.get(Vue.config.API_URL + 'blog/enable/' + post_id)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					success(resp.data.post);
				}

			})
			.catch(function (resp) {


			});
	}

	static createArticle(project_id,newPost,callback){
		axiosApi.post(Vue.config.API_URL + 'projects/articles/add/'+project_id, newPost)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					callback({iserror: false, post_id: resp.data.post_id,alias:resp.data.alias});
				} else {

					callback({iserror: true, error_message: resp.data.message});
				}

			})
			.catch(function (resp) {
				callback({iserror: true, error_message: "Произошла ошибка"});

			});
	}
	static createPost(newPost, callback) {

		axiosApi.post(Vue.config.API_URL + 'blog/addpost', newPost)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					callback({iserror: false, post_id: resp.data.post_id,alias:resp.data.alias});
				} else {

					callback({iserror: true, error_message: resp.data.message});
				}

			})
			.catch(function (resp) {
				callback({iserror: true, error_message: "Произошла ошибка"});

			});
	}


	static createProject(newProject, callback) {

		axiosApi.post(Vue.config.API_URL + 'projects/add', newProject)
			.then(function (resp) {
				//alert('Успешно!');
				if (resp.data.type == "success") {

					callback({'data':resp.data,iserror: false, project_id: resp.data.project_id});
				} else {

					callback({iserror: true, error_message: resp.data.message});
				}

			})
			.catch(function (resp) {
				callback({iserror: true, error_message: "Произошла ошибка"});

			});
	}

	static loadDeveloperItems(username,success,error){

		axiosApi.get(Vue.config.API_URL + 'developer/items/' + username)
			.then(function (resp) {

				if (resp.data.type == "success") {
					var developer_data = resp.data;


					success(developer_data);
				}else {
					error();
				}


			})
			.catch(function () {

			});
	}
	static loadDeveloperReviews(username, success) {


		axiosApi.get(Vue.config.API_URL + 'developer/reviews/' + username)
			.then(function (resp) {

				if (resp.data.type == "success") {
					var developer_data = resp.data;


					success(developer_data);
				}


			})
			.catch(function () {

			});
	}

	static loadDeveloperWork(username, work_id, success,error) {


		axiosApi.get(Vue.config.API_URL + 'developer/work/' + username + "/" + work_id)
			.then(function (resp) {

				if (resp.data.type == "success") {
					var developer_data = resp.data.developer;
					var work = resp.data.work;


					success(developer_data, work);
				}else {
					error();
				}


			})
			.catch(function () {

			});
	}

	static loadDeveloper(username) {


		axiosApi.get(Vue.config.API_URL + 'developer/' + username)
			.then(function (resp) {

				if (resp.data.type == "success") {
					var developer_data = resp.data.developer;


					eventBus.$emit('load_developer_user', developer_data);
				}


			})
			.catch(function () {

			});
	}

	static loadDeveloperv2(username,callback,error) {


		axiosApi.get(Vue.config.API_URL + 'developer/' + username)
			.then(function (resp) {

				if (resp.data.type == "success") {
					var developer_data = resp.data.developer;
					callback(resp.data);


					//eventBus.$emit('load_developer_user', developer_data);
				}else {
					error();
				}


			})
			.catch(function () {

			});
	}

	static loadUserPortfolio() {


		axiosApi.get(Vue.config.API_URL + 'portfolio/all')
			.then(function (resp) {


				eventBus.$emit('load_portfolio_user', resp.data);


			})
			.catch(function () {

			});
	}


}